import { createSelector } from 'reselect';

import { VANILLA_SETTLING_ASSET } from 'constants/constants';
import { LOCALES } from 'constants/dateTime';
import { CURRENCY_TYPE } from 'constants/enums';
import { formatFiat } from 'helpers/currency';
import { prop } from 'helpers/ramda';
import {
  cropAfterDecimals,
  addZeroesUntilCorrectPrecision,
  convertFromUSDtoINR,
} from 'helpers/utils';

import { inrConversionRateSelector } from './otherSelectors';
import { balanceBySymbolSelector, usdAssetMinPrecisionSelector } from './walletSelector';

const referralBonusSelector = createSelector([balanceBySymbolSelector], allBalances => {
  const { referral_bonus: referralBonus } =
    prop(VANILLA_SETTLING_ASSET as string, allBalances) ?? {};
  return referralBonus;
});

const referralBonusAmountInINRSelector = createSelector(
  [referralBonusSelector, inrConversionRateSelector, usdAssetMinPrecisionSelector],
  (referralBonus, inrConversionRate, usdAssetMinPrecision) => {
    const referralBonusAmountInINR = cropAfterDecimals(
      addZeroesUntilCorrectPrecision(
        convertFromUSDtoINR(Number(referralBonus), inrConversionRate),
        usdAssetMinPrecision
      ),
      usdAssetMinPrecision
    );

    return referralBonusAmountInINR;
  }
);

const referralBonusFormattedInUSDSelector = createSelector(
  [referralBonusSelector, usdAssetMinPrecisionSelector],
  (referralBonus, usdAssetMinPrecision) => {
    const referralBonusFormattedInUSD = formatFiat(
      CURRENCY_TYPE.USD,
      cropAfterDecimals(
        addZeroesUntilCorrectPrecision(Number(referralBonus), usdAssetMinPrecision),
        usdAssetMinPrecision
      )
    );

    return referralBonusFormattedInUSD;
  }
);

const referralBonusFormattedInINRSelector = createSelector(
  [referralBonusAmountInINRSelector, usdAssetMinPrecisionSelector],
  (referralBonusAmountInINR, usdAssetMinPrecision) => {
    const referralBonusFormattedInInr = formatFiat(
      CURRENCY_TYPE.INR,
      cropAfterDecimals(
        addZeroesUntilCorrectPrecision(
          Number(referralBonusAmountInINR),
          usdAssetMinPrecision
        ),
        usdAssetMinPrecision
      ),
      LOCALES.INDIA
    );

    return referralBonusFormattedInInr;
  }
);

export {
  referralBonusSelector,
  referralBonusAmountInINRSelector,
  referralBonusFormattedInUSDSelector,
  referralBonusFormattedInINRSelector,
};
